import { useState } from "react";

type FileExtension = ".pdf" | ".rar" | ".zip" | ".pdf" | ".pdf" 

const useDownloadFile = () => {
    const [isDownloading, setIsDownloading] = useState<boolean>(false);

    const downloadFile = async (url: string, fileExtension: FileExtension, name?: string) => {
        try {
            setIsDownloading(true);

            const response = await fetch(url);
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);

            const downloadLink = document.createElement('a');
            const fileName = name ? `${name}${fileExtension}` : `${name}${fileExtension}`;
            downloadLink.href = downloadUrl;
            downloadLink.download = fileName;
            downloadLink.click();

            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error('Error downloading the file:', error);
        } finally {
            setIsDownloading(false);
        }
    };

    return { isDownloading, downloadFile };
};

export default useDownloadFile;
